var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47468",
    "data-name": "Group 47468",
    transform: "translate(-342 -35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8275",
    "data-name": "Rectangle 8275",
    width: 32,
    height: 32,
    transform: "translate(342 35)",
    fill: "#36297d",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "menu",
    d: "M8,78.4a1.6,1.6,0,0,1,1.6-1.6H30.4a1.6,1.6,0,0,1,0,3.2H9.6A1.6,1.6,0,0,1,8,78.4Zm22.4,8H1.6a1.6,1.6,0,0,0,0,3.2H30.4a1.6,1.6,0,0,0,0-3.2Zm0,9.6H16a1.6,1.6,0,0,0,0,3.2H30.4a1.6,1.6,0,1,0,0-3.2Z",
    transform: "translate(342 -37.2)",
    fill: "#36297d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.3f4f56d65bc66be3eb73f9244c7732f2.svg";
export { ForwardRef as ReactComponent };